import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { useParams, generatePath } from 'react-router-dom';

import BreadcrumbContext from './BreadcrumbsContext';

const withBreadcrumb = (WrappedComponent) => {
  const Bc = (props) => {
    const { register, unregister } = useContext(BreadcrumbContext);
    const params = useParams();

    const { label, pathPattern } = props;
    const path = generatePath(pathPattern, params);

    useEffect(() => {
      register(label, path);
      return () => unregister(label);
    }, [label, register, unregister, path]);

    return <WrappedComponent {...props} />;
  };

  Bc.defaultProps = {
    children: null,
    label: '',
    pathPattern: '',
  };

  Bc.propTypes = {
    children: PropTypes.node,
    label: PropTypes.string,
    /**
     * The absolute path to the <WrappedComponent>, with URL parameters
     */
    pathPattern: PropTypes.string,
  };

  return Bc;
};

export default withBreadcrumb;
